import React, {Component} from 'react'
import { AutoNotification } from './AutoNotification'
import parse from 'html-react-parser';
import Modal from "./Modal";
import {getNotifications, putNotifications} from "../../services/vu";

class AutoNotifications extends Component {
  constructor(props) {
    super(props)

    this.state = {
      openModal: false,
      notifications: [],
      notification : {
        "id": "",
        "originId": "",
        "type": "",
        "courseCode": "",
        "academicYear": "",
        "priority": "",
        "status": "",
        "message": {
          "title": "",
          "body": ""
        },
        "action": [
          {
            "label": "",
            "url": ""
          },
          {
            "label": "",
            "url": ""
          }
        ],
        "teachingPeriodCalculator": {
          "instanceSequenceNumber": "",
          "type": ""
        }
      },
    }
  }

  componentDidMount() {
    getNotifications().then(notifications => {
    this.setState({
      notifications : notifications
    }, () => {
        AutoNotifications.updateNotificationsStatus(notifications, 'Presented');
       })
    })


    /*this.setState({
      notifications : [
            {
              "id": "123",
              "originId": "VUConnect",
              "type": "HE Domestic Fees & TFN",
              "courseCode": "BBI61",
              "academicYear": "2018",
              "priority": "1",
              "status": "Presented",
              "message": {
                "title": "TFN/Fee Notifications for Fee Defer Eligible students (DOM only).",
                "body": "TFN/Fee Notifications for Fee Defer Eligible students (DOM only) ordered by proximity to Census Date."
              },
              "action": [
                {
                  "label": "Action Label 1",
                  "url": "https://vu-pmo.atlassian.net/browse/DSE-725"
                },
                {
                  "label": "Action Labe 2",
                  "url": "https://vu-pmo.atlassian.net/browse/DSE-937"
                }
              ],
              "teachingPeriodCalculator": {
                "instanceSequenceNumber": "123",
                "type": "CTYpe"
              }
            },
            {
              "id": "456",
              "originId": "VUConnect",
              "type": "HE Domestic Fees & TFN",
              "courseCode": "BBI61",
              "academicYear": "2018",
              "priority": "1",
              "status": "Presented",
              "message": {
                "title": "Fee Notifications for Defer Ineligible students (DOM only).",
                "body": "Fee Notifications for Defer Ineligible students (DOM only) ordered by proximity to Payment Due Date"
              },
              "action": [
                {
                  "label": "Action Label 1",
                  "url": "https://vu-pmo.atlassian.net/browse/DSE-725"
                },
                {
                  "label": "Action Labe 2",
                  "url": "https://vu-pmo.atlassian.net/browse/DSE-937"
                }
              ],
              "teachingPeriodCalculator": {
                "instanceSequenceNumber": "123",
                "type": "CTYpe"
              }
            }
          ]
    }, () => {
      AutoNotifications.updateNotificationsStatus(this.state.notifications, 'Presented');
    })*/
  }

  static updateNotificationsStatus(notifications = [], status) {
    putNotifications(notifications.map(notification => {
      return {
        ...notification,
        status: status,
      }
    }))
  }

  componentDidUpdate(prevProps) {
    if (prevProps.course !== this.props.course) {
      this.initialiseEnrolledUnits(this.props.course)
    }
  }

  handleOpenModal = (notification) => {
    return () => {
      this.setState({
        openModal: true,
        notification: notification
      })
      AutoNotifications.updateNotificationsStatus([notification], 'Read');
    }
  }

  handleCloseModal = () => {
    this.setState({
      openModal: false
    })
  }

  render() {
    return (
      <div>
        {this.state.notifications.map((notification, index) => {
          return (
            <AutoNotification
              key={index}
              title={notification.message.title}
              priority={notification.priority}
              onClick={this.handleOpenModal(notification)}
            />
          )
        })}

        <Modal
          className={`modal modal-xl modal-notification`}
          isOpen={this.state.openModal}
          handleCloseModal={() => this.handleCloseModal()}
          title={this.state.notification.message.title}
          priority ={this.state.notification.priority}
        >
          <div className="content">
            <p>
            {parse(this.state.notification.message.body)}
            </p>
          </div>

          <div className="actionItem">
            {
              this.state.notification.action.map((action, index) => {
                return (
                  <a key={index} className="btn btn-sm btn-tertiary btn-notification-action" href={action.url} target="_blank">{action.label}</a>
                )
              })
            }
          </div>
        </Modal>
      </div>
    )
  }
}

export default AutoNotifications
